import type { StripeError } from '@stripe/stripe-js';

const STRIPE_ERROR_COPY_KEYS: Record<string, string> = {
  card_not_supported: 'stripeErrors.cardNotSupported',
  expired_card: 'stripeErrors.expiredCard',
  incorrect_cvc: 'stripeErrors.incorrectCvc',
  incorrect_number: 'stripeErrors.incorrectNumber',
  incorrect_zip: 'stripeErrors.incorrectZip',
  insufficient_funds: 'stripeErrors.insufficientFunds',
  payment_limit_exceeded: 'stripeErrors.paymentLimitExceeded',
};

const GENERIC_STRIPE_ERROR_KEY = 'stripeErrors.generic';

export const resolveStripeErrorKey = (
  error: Pick<StripeError, 'code' | 'decline_code'>,
): string => {
  const declineCodeKey = error.decline_code
    ? STRIPE_ERROR_COPY_KEYS[error.decline_code]
    : undefined;
  const codeKey = error.code ? STRIPE_ERROR_COPY_KEYS[error.code] : undefined;

  return declineCodeKey ?? codeKey ?? GENERIC_STRIPE_ERROR_KEY;
};

export const isStripeErrorKey = (key: string): boolean => {
  return key.startsWith('stripeErrors.');
};
